/**
 * ScopedCustomStyle — renders an admin's per-view custom CSS, scoped to
 * `#{scopeId}` so it cannot restyle anything outside that view's content
 * container (navbar, breadcrumbs, other tables' public pages).
 */

import { useMemo } from 'react';
import { buildScopedCss } from '../../utils/scopedCustomCss';

export default function ScopedCustomStyle({ css, scopeId }) {
  const scopedCss = useMemo(() => buildScopedCss(css, scopeId), [css, scopeId]);
  if (!scopedCss) return null;
  return <style>{scopedCss}</style>;
}
